import { render, staticRenderFns } from "./findPassword.vue?vue&type=template&id=bfd7523e&scoped=true&"
import script from "./findPassword.vue?vue&type=script&lang=js&"
export * from "./findPassword.vue?vue&type=script&lang=js&"
import style0 from "./findPassword.vue?vue&type=style&index=0&id=bfd7523e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd7523e",
  null
  
)

export default component.exports